import type { ReactNode } from "react";
import { cx } from "../cx.js";
import styles from "./Feedback.module.css";

export function EmptyState({
  icon,
  title,
  children,
}: {
  icon?: ReactNode;
  title: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className={styles.empty}>
      {icon ? (
        <span className={styles.emptyIcon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <p className={styles.emptyTitle}>{title}</p>
      {children ? <p className={styles.emptyText}>{children}</p> : null}
    </div>
  );
}

export function Skeleton({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cx(styles.skeleton, className)} aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <span key={i} className={styles.line} style={{ inlineSize: `${90 - i * 15}%` }} />
      ))}
    </div>
  );
}

export function Spinner({ label, size = 24 }: { label: string; size?: number }) {
  return (
    <span role="status" className={styles.spinnerWrap}>
      <svg className={styles.spinner} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="none" strokeWidth="3" />
      </svg>
      <span className="omony-visually-hidden">{label}</span>
    </span>
  );
}

/** Kurzbefehl-Anzeige, z. B. im Leitstand */
export function Kbd({ children }: { children: ReactNode }) {
  return <kbd className={styles.kbd}>{children}</kbd>;
}
